export const OVERLAY_IDS = {
  mcBlockSight: "mcBlockSight",
  mcMiniMap: "mcMiniMap",
};
